import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import {
  MobileMenuContainer,
  MobileMenuHeader,
  CloseButton,
  MobileNav,
  MobileNavItem
} from './styles';

interface MobileMenuProps {
  isOpen: boolean;
  toggleMobileMenu: () => void;
}

const MobileMenu: React.FC<MobileMenuProps> = ({ isOpen, toggleMobileMenu }) => {
  const { language } = useLanguage();
  return (
    <MobileMenuContainer isOpen={isOpen}>
      <MobileMenuHeader>
        <h2>Menu</h2>
        <CloseButton onClick={toggleMobileMenu}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
          </svg>
        </CloseButton>
      </MobileMenuHeader>
      
      <MobileNav>
        <MobileNavItem>
          <Link to="/" onClick={toggleMobileMenu}>{language === 'pt' ? 'Início' : 'Home'}</Link>
        </MobileNavItem>
        <MobileNavItem>
          <Link to="/servicos" onClick={toggleMobileMenu}>{language === 'pt' ? 'Serviços' : 'Services'}</Link>
        </MobileNavItem>
        <MobileNavItem>
          <Link to="/produtos" onClick={toggleMobileMenu}>{language === 'pt' ? 'Produtos' : 'Products'}</Link>
        </MobileNavItem>
        <MobileNavItem>
          <Link to="/sobre" onClick={toggleMobileMenu}>{language === 'pt' ? 'Sobre' : 'About'}</Link>
        </MobileNavItem>
        <MobileNavItem>
          <Link to="/contacto" onClick={toggleMobileMenu}>{language === 'pt' ? 'Contacto' : 'Contact'}</Link>
        </MobileNavItem>
      </MobileNav>
    </MobileMenuContainer>
  );
};

export default MobileMenu;